export default "__VITE_ASSET__1CwQeOAs__"